var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hunters-calling"},[_vm._m(0),_c('BookPage',{attrs:{"title":"O Chamado do Caçador","pages":"60","bookImg":_vm.coverCdC,"synopsis":[
        "Após quatro anos sozinho, Vicente faz uma visita à vila onde seu antigo companheiro de jornada se \n        estabelecera. Tinha esperanças de que o reencontro o ajudasse a aposentar sua espada, a abandonar o \n        ofício de caçador, a buscar um novo propósito…",
        "No entanto, a vila lhe guardava mais um trabalho a ser feito: enquanto crianças desaparecem de dentro \n        de suas casas, um monstro vaga pela noite perturbando o descanso dos mortos.",
        "Que aquela fosse, então, sua última caçada."
    ],"stores":[{
        image: _vm.amazon,
        link: 'https://amzn.to/2IeQWSX',
        linkName: 'Ebook'
    }, {
        mail: true
    }]}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-title"},[_c('img',{attrs:{"src":require("@/assets/img/title-chamado.svg"),"alt":""}})])}]

export { render, staticRenderFns }